import {Component, inject} from '@angular/core';
import {ConfiguratorRouterExtractorService} from '@spartacus/product-configurator/common';
import {ConfiguratorMessageConfig, ConfiguratorUpdateMessageComponent} from '@spartacus/product-configurator/rulebased';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {DcpConfiguratorCommonsService} from '../../services';
import {serviceProviderTokens} from '../../token/tokens';

@Component({
  selector: 'dcp-configurator-update-message',
  templateUrl: './dcp-configurator-update-message.component.html',
  styleUrls: ['./dcp-configurator-update-message.component.scss'],
  standalone: false,
})
export class DcpConfiguratorUpdateMessageComponent extends ConfiguratorUpdateMessageComponent {
  private cartDecoratorErrorHandlingService = inject(
    serviceProviderTokens.CART_DECORATOR_ERROR_HANDLING_SERVICE_PROVIDER,
  );

  initialLoading$: Observable<boolean> = this.configuratorCommonsService.getState().initialLoading;
  hasError$: Observable<boolean> = this.cartDecoratorErrorHandlingService.getErrorState$().pipe(map((e) => e.hasError));
  skipConfigurator$: Observable<boolean> = this.configuratorCommonsService.skipConfigurator.asObservable();

  constructor(
    protected override configuratorCommonsService: DcpConfiguratorCommonsService,
    protected override configRouterExtractorService: ConfiguratorRouterExtractorService,
    protected override config: ConfiguratorMessageConfig,
  ) {
    super(configuratorCommonsService, configRouterExtractorService, config);
  }
}
